class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");

    if (this.buttonClose) {
      this.buttonClose.addEventListener(
        "click",
        this.closeNewsletter.bind(this)
      );
    }

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;

    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");

    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector(
      "age-verification-popup"
    );

    // Newsletter-Popup bleibt 30 Tage geschlossen
    this.cookieDuration = 30;
  }

  /**
   * Setzt ein Cookie für die angegebene Anzahl an Tagen.
   */
  setNewsletterCookie(name) {
    const expires = new Date();

    expires.setTime(
      expires.getTime() +
        this.cookieDuration * 24 * 60 * 60 * 1000
    );

    document.cookie =
      name +
      "=true; expires=" +
      expires.toUTCString() +
      "; path=/; SameSite=Lax";
  }

  closeNewsletter() {
    this.setNewsletterCookie("newsletter-closed");

    this.closed = "true";

    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }

      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (
      getCookie("age-verified") !== "true" &&
      this.ageVerificationPopup
    ) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains(
      "newsletter-popup-is-hidden"
    );

    const observer = new MutationObserver((mutations) => {
      const mutation = mutations[0];

      if (mutation.attributeName !== "class") return;

      const currentClassState =
        mutation.target.classList.contains(
          "newsletter-popup-is-hidden"
        );

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;

        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, {
      attributes: true,
    });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      // Popup wird nur angezeigt, wenn der Besucher es in
      // den letzten 30 Tagen weder geschlossen noch abonniert hat.
      if (
        getCookie("newsletter-closed") !== "true" &&
        getCookie("newsletter-subscribed") !== "true"
      ) {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe(event) {
    this.setNewsletterCookie("newsletter-subscribed");

    this.subscribed = "true";

    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);